module.exports = __webpack_public_path__ + "static/img/market05.bde5d13e.png";